import { __ } from '@wordpress/i18n'

export default {
  alle: __('Alle Veranstaltungen', 'dhsv_theme'),
  link_title: __('Mehr erfahren', 'dhsv_theme'),
  tag_des_offenen_holzhauses: __('Tag des offenen Holzhauses', 'dhsv_theme'),
}
